import React, {Component} from 'react';
import {Button, Col, Modal, ModalBody, ModalHeader, Row} from 'reactstrap';
import NewProjectForm from './NewProjectForm.js';
import DeleteProjectForm from './DeleteProjectForm.js';

class CreateModal extends Component {
	render() {
		let headerText = '';
		let formBody = [];

		switch (this.props.createModalSection) {
		case 'DELETE':
			headerText = `Delete Project: P#${this.props.route}`;
			formBody.push(
				<DeleteProjectForm
					key="1"
					apiPrefix={this.props.apiPrefix}
					md5GetQueryParams={this.props.md5GetQueryParams}
					md5PostXAuthHeaders={this.props.md5PostXAuthHeaders}
					createModalSubsection={this.props.createModalSubsection}
					changeModalSubsection={this.props.changeModalSubsection}
					goBackToSplash={this.props.goBackToSplash}
					route={this.props.route}
					setLoading={this.props.setLoading}
					toggleCreateModal={this.props.toggleCreateModal}
				/>
			);
			break;
		case 'NEW_PROJ':
		default:
			headerText = 'Create a New Project';
			formBody.push(
				<NewProjectForm
					key="2"
					apiPrefix={this.props.apiPrefix}
					md5PostXAuthHeaders={this.props.md5PostXAuthHeaders}
					createModalSubsection={this.props.createModalSubsection}
					changeModalSubsection={this.props.changeModalSubsection}
					handleGetRouteFromSearch={this.props.handleGetRouteFromSearch}
					toggleCreateModal={this.props.toggleCreateModal}
					routeData={this.props.routeData}
					setLoading={this.props.setLoading}
					makeLabel={this.props.makeLabel}
				/>
			);
			break;
		}

		return (
			<div>
				<Modal
					isOpen={this.props.createModalShow}
					toggle={this.props.toggleCreateModal}
					className="create-modal"
				>
					<ModalHeader toggle={this.props.toggleCreateModal} className="h2">
						{headerText}
					</ModalHeader>
					<ModalBody>{formBody}</ModalBody>
				</Modal>
			</div>
		);
	}
}

export default CreateModal;



// WEBPACK FOOTER //
// ./src/components/CreateModal.js